import { AUTHENTICATE_COMPLETE, CHANGE_RETAILER_ID, LOGIN_CLEAR_ERROR, LOGIN_START, LOGIN_COMPLETE, LOGIN_ERROR, LOGIN_CLEAR_VALIDATION_ERRORS, LOGIN_SET_REMEMBER_RETAILER_ID, STORE_USER_METADATA_START, STORE_USER_METADATA_ERROR, STORE_USER_METADATA_COMPLETE } from './login.action-types';
import { logIamFailure } from '@common/iam-login-log';
const logger = svs.core.log.getLogger('welcome/store/login/actions');
export const changeRetailerId = retailerId => ({
  type: CHANGE_RETAILER_ID,
  retailerId
});
export const authenticateComplete = ({
  isBankIdLogin,
  isLoginThisDevice,
  mustChangePassword
} = {}) => {
  const action = {
    type: AUTHENTICATE_COMPLETE,
    isBankIdLogin,
    isLoginThisDevice,
    mustChangePassword
  };
  return action;
};
export const loginClearError = () => ({
  type: LOGIN_CLEAR_ERROR
});
export const storeUserMetadata = userProfile => (dispatch, getState) => {
  const logProfileFailure = (reason, field) => {
    try {
      return logIamFailure(logger, {
        method: 'unknown',
        retailerId: userProfile?.retailer?.id ?? getState?.()?.login?.retailerId,
        stage: 'metadata',
        reason,
        field
      });
    } catch {
      return false;
    }
  };
  dispatch({
    type: STORE_USER_METADATA_START
  });
  if (!userProfile || !userProfile.retailer) {
    logProfileFailure('metadata_missing');
    return dispatch({
      type: STORE_USER_METADATA_ERROR
    });
  }
  const retailerInfo = {
    basicCategory: userProfile.retailer.basicCategory,
    retailerId: userProfile.retailer.id,
    sellType: userProfile.retailer.sellType,
    sellTypeId: userProfile.retailer.sellTypeId
  };
  const missingFields = Object.keys(retailerInfo).filter(k => !retailerInfo[k]).join(', ');
  const userInfo = {
    name: userProfile.user.name,
    retailer: retailerInfo,
    role: userProfile.user?.role
  };
  svs.core.userSession.set('userInfo', userInfo, err => {
    if (err || missingFields.length > 0) {
      if (err) {
        logProfileFailure('metadata_persistence_failed');
      } else {
        logProfileFailure('metadata_missing', missingFields.replaceAll(', ', '_'));
      }
      return dispatch({
        type: STORE_USER_METADATA_ERROR
      });
    }
    dispatch({
      type: STORE_USER_METADATA_COMPLETE
    });
  });
};
export const loginStart = ({
  retailerId,
  username,
  password,
  rememberRetailerId
} = {}) => ({
  type: LOGIN_START,
  retailerId,
  username,
  password,
  rememberRetailerId
});
export const loginComplete = () => {
  return {
    type: LOGIN_COMPLETE
  };
};
export const loginError = error => ({
  type: LOGIN_ERROR,
  error
});
export const loginClearValidationErrors = () => ({
  type: LOGIN_CLEAR_VALIDATION_ERRORS
});
export const setRememberRetailerId = rememberRetailerId => ({
  type: LOGIN_SET_REMEMBER_RETAILER_ID,
  rememberRetailerId
});